import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { DateTime } from 'scaleflow/utils/date-time';

const STAGGER_DELAY_MS = 300;

export default class ChatBotMessageComponent extends Component {
  @service store;
  @service chatv2;

  @tracked element;
  @tracked messageIsCopied = false;
  @tracked artifactIsCreated = false;

  @action
  animateIn(index, element) {
    // Calculate the total delay for this specific element
    const delay = (index + 1) * STAGGER_DELAY_MS;

    // Apply the 'animated' class after the calculated delay to trigger transition
    // This simulates the 'opacity-0' to 'opacity-100' transition from Tailwind
    setTimeout(() => {
      element.classList.add('opacity-100');
      element.classList.remove('opacity-0');
      element.classList.add('translate-x-0');
      element.classList.remove('translate-x-4'); // Assumes it starts slightly lower
    }, delay); // Use the calculated delay for each item
  }

  @action
  setMarkdownElement(element) {
    this.element = element;
  }

  @action
  copyMessageToClipboard() {
    if (!this.element) return;
    const textContent = this.element.innerText;
    navigator.clipboard.writeText(textContent);
    this.showMessageCopiedAnimation();
  }

  @action
  showMessageCopiedAnimation() {
    this.messageIsCopied = true;
    setTimeout(() => {
      this.messageIsCopied = false;
    }, 3000);
  }

  @action
  saveAsArtifact() {
    const conversation_id = this.chatv2.activeConversation;
    const conversation = this.store.peekRecord('conversation', conversation_id);
    const title = conversation.title;
    const initiative_id = conversation.initiative.id;
    const initiative = this.store.peekRecord('initiative', initiative_id);
    let artifact_title = title.split('-')?.[0]?.trim?.() ?? title;
    artifact_title += ` - ${DateTime.now().format('DD-MM-YYYY HH:mm')}`;
    const artifact = this.store.createRecord('artifact', {
      name: artifact_title,
      content: this.args.message.text,
      initiative: initiative,
    });
    artifact
      .save()
      .then(() => {
        this.artifactIsCreated = true;
        setTimeout(() => {
          this.artifactIsCreated = false;
        }, 3000);
      })
      .catch((error) => {
        console.error('Error saving artifact:', error);
        this.artifactIsCreated = false;
      });
  }
}
